<template>
  <div>
    <HeroSecondary
      v-if="hero"
      v-bind="hero"
    >
      <LinkCta
        :href="mailto"
        class="ViewProgram__cta"
      />
    </HeroSecondary>
    <BackgroundBlades>
      <div class="ViewProgram__container">
        <ViewProgramDetails
          v-if="details"
          :mailto="mailto"
          v-bind="details"
          class="details"
        />
        <ProgramExperience
          v-if="experience"
          v-bind="experience"
          :name="name"
          :mailto="mailto"
          class="experience"
        />
      </div>
    </BackgroundBlades>
    <CategoryLinks/>
  </div>
</template>

<script>
  import Option from '@/api/options';
  import Program from '@/api/programs';
  import { cleanProgram } from '@/util/cleaners';

  import LinkCta from './LinkCta';
  import HeroSecondary from './HeroSecondary';
  import CategoryLinks from './CategoryLinks';
  import BackgroundBlades from './BackgroundBlades';
  import ProgramExperience from './ProgramExperience';
  import ViewProgramDetails from './ViewProgramDetails';

  export default {
    components: {
      LinkCta,
      HeroSecondary,
      CategoryLinks,
      BackgroundBlades,
      ProgramExperience,
      ViewProgramDetails,
    },
    data() {
      return {
        name: undefined,
        hero: undefined,
        experience: undefined,
        details: undefined,
        emailAddress: undefined,
        emailSubject: undefined,
        emailTemplate: undefined,
      };
    },
    computed: {
      mailto() {
        const {
          name,
          signUpUrl,
          emailAddress,
          emailSubject,
          emailTemplate,
        } = this;

        if (signUpUrl) {
          return signUpUrl;
        }

        if (!(name && emailAddress)) {
          return null;
        }

        return `mailto:${emailAddress}?subject=${emailSubject.replace(/{{\s*name\s*}}/g, this.name).replace(/&#8217;/g, "'")}&body=${emailTemplate.replace(/{{\s*name\s*}}/g, this.name).replace(/\n/g, '%0D%0A').replace(/&#8217;/g, "'")}`;
      },
    },
    created() {
      this.fetchProgram();
      this.fetchEmailTemplate();
    },
    methods: {
      async fetchProgram() {
        const program = cleanProgram(await Program.where('slug', this.$route.params.program).first());

        Object.assign(this, program);

        this.$store.commit('setViewName', program.name);
      },
      async fetchEmailTemplate() {
        const {
          email_address: emailAddress,
          email_subject: emailSubject,
          email_template: emailTemplate,
        } = (await Option.find('theme-settings')).acf;

        Object.assign(this, { emailAddress, emailSubject, emailTemplate });
      },
    },
  };
</script>

<style lang="scss">
  .ViewProgram__container {
    @include container;
    padding-top: spacing(base-delta);
    padding-bottom: spacing(base-epsilon);

    @include breakpoint(phablet) {
      padding-top: spacing(base-eta);
      padding-bottom: spacing(base-eta);
    }
  }

  .ViewProgram__cta {
    display: none;

    @include breakpoint(tablet) {
      display: block;
    }
  }

  .experience {
    .details + & {
      margin-top: spacing(base-zeta);
    }
  }
</style>
